import { IResponse } from "../../Data/Interfaces/Base/IResponse";
import { IVeterinario } from "../../Data/Interfaces/Request/Veterinario/IVeterinario";
import { createAction, Action, ActionsUnion } from "../../Utils/actionHelpers";

export enum VeterinarioActionKeys {
  GET_ALL_VETERINARIOS_SUCCESS = "[VETERINARIOS]GET_ALL_VETERINARIOS_SUCCESS",
  NEXT_PAGE_VETERINARIOS_SUCCESS = "[VETERINARIOS]NEXT_PAGE_VETERINARIOS_SUCCESS",

  SET_LOADING = "[VETERINARIOS]SET_LOADING",
}

export const VeterinarioActions = {
  getAllVeterinariosSuccess: (
    data: IResponse<IVeterinario[]>
  ): AllVeterinariosSuccessAction =>
    createAction(VeterinarioActionKeys.GET_ALL_VETERINARIOS_SUCCESS, data),

  nextPageVets: (): NextPageVetAction =>
    createAction(VeterinarioActionKeys.NEXT_PAGE_VETERINARIOS_SUCCESS),

  setLoading: (isLoading: boolean): StartLoadingAction =>
    createAction(VeterinarioActionKeys.SET_LOADING, isLoading),
};

export type VeterinarioActionUnion = ActionsUnion<typeof VeterinarioActions>;

export type AllVeterinariosSuccessAction = Action<
  VeterinarioActionKeys.GET_ALL_VETERINARIOS_SUCCESS,
  IResponse<IVeterinario[]>
>;

export type NextPageVetAction =
  Action<VeterinarioActionKeys.NEXT_PAGE_VETERINARIOS_SUCCESS>;

export type StartLoadingAction = Action<
  VeterinarioActionKeys.SET_LOADING,
  boolean
>;
